import React, { useState } from 'react';
import { ShieldAlert, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { jsonApi } from '@/lib/jsonApi';
import { Button } from '@/components/ui/button';

const RESULT = {
  masked: 'Profanity found — masked copy saved. Originals untouched.',
  clean: 'No profanity found.',
  no_text: 'Nothing to check — no written or transcribed text.',
  filter_off: 'Profanity Filter is OFF for this client — nothing changed.',
  error: 'Check could not finish — nothing changed. Please try again.',
};

// satisFIND admin: re-run the profanity check for this one response.
export default function ProfanityRecheck({ responseId, onDone }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const d = await jsonApi(`/platform/responses/${encodeURIComponent(responseId)}/recheck-profanity`, 'POST');
      (d.status === 'error' ? toast.error : toast.success)(RESULT[d.status] || 'Done');
      onDone();
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <div className="flex items-center justify-between gap-3 bg-[#F8FAFC] border border-[#E2E8F0] rounded-xl px-4 py-2.5" data-testid="profanity-recheck-strip">
      <span className="text-xs text-[#475569] flex items-center gap-2"><ShieldAlert className="w-4 h-4 text-[#1A3E6F]" /> Profanity filter · re-check this response (satisFIND admin)</span>
      <Button size="sm" variant="outline" disabled={busy} onClick={run} data-testid="profanity-recheck-btn">
        {busy && <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" />}Re-check profanity
      </Button>
    </div>
  );
}
